export default __webpack_public_path__ + "static/media/kuulolaitehuolto-darkblue.3c484335.svg";